<template>
  <div
    :class="{
      'input-box': true,
      'active-border': activeBorder,
      'padding-class': isPadding,
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    activeBorder: {
      type: Boolean,
      required: false,
      default: false,
    },
    isPadding: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.input-box {
  display: flex;
  align-items: center;
  height: 56px;
  // background: rgba(247, 248, 250, 0.5);
  border: 1px solid rgba(0, 67, 178, 0);
  border-radius: 8px;
  box-sizing: border-box;
  // padding: 19px 22px;
  margin-bottom: 24px;
  // transition: all 0.3s;
  transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;

  &:hover {
    border-color: #aaaaaa;
  }
}

.padding-class {
  padding: 19px 22px;
}

.active-border {
  background: rgba(216, 216, 216, 0);
  box-shadow: 0px 0px 0px 2px rgba(51, 112, 255, 0.24);
  border-radius: 8px;
  border-color: #3370ff !important;
}
</style>
